{
  "version": 1,
  "asset_id": "5a2442c3-10e1-45bf-9242-1dd3534cb420",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/5a2442c3-10e1-45bf-9242-1dd3534cb420/hero-savings.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/5a2442c3-10e1-45bf-9242-1dd3534cb420/hero-savings.jpg",
  "original_filename": "hero-savings.jpg",
  "size": 123918,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:10Z"
}
